module.exports = __webpack_public_path__ + "static/media/cms2.f8d12cbb.png";